import { render, staticRenderFns } from "./NewContactPersonDialog.vue?vue&type=template&id=0b15f241&scoped=true&"
import script from "./NewContactPersonDialog.vue?vue&type=script&lang=js&"
export * from "./NewContactPersonDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewContactPersonDialog.vue?vue&type=style&index=0&id=0b15f241&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15f241",
  null
  
)

component.options.__file = "NewContactPersonDialog.vue"
export default component.exports